// =========================================
// FULL EMOJI DATA MODULE
// =========================================

// -------------------------------
// CATEGORY DEFINITIONS
// -------------------------------
export const EMOJI_CATEGORIES = [
  { name: 'smileys', icon: '😀', label: 'Smileys & Emotion' },
  { name: 'people', icon: '👍', label: 'People' },
  { name: 'animals', icon: '🐶', label: 'Animals' },
  { name: 'food', icon: '🍔', label: 'Food' },
  { name: 'sports', icon: '⚽', label: 'Sports' },
  { name: 'objects', icon: '💡', label: 'Objects' },
  { name: 'celebrations', icon: '🎉', label: 'Celebrations' },
  { name: 'custom', icon: '<img src="assets/pictures/sing-snap-logo.png" width="18" height="18">', label: 'Custom' },
];


// -------------------------------
// EMOJI LISTS (GROUPED)
// -------------------------------
export const EMOJI_DATA: Record<string, string[]> = {
  smileys: [
    '😀','😁','😂','🤣','😃','😄','😅','😆','😉','😊',
    '😋','😎','😍','😘','😗','😙','😚','🙂','🤗','🤩',
    '🤔','🤨','😐','😑','😶','🙄','😏','😣','😥','😮',
    '🤐','😯','😪','😫','😴','😌','🤤','😛','😜','😝',
    '😒','😓','😔','😕','🙃','🫠','🤑','😲','☹️','🙁',
    '😖','😞','😟','😤','😢','😭','😦','😧','😨','😩',
    '🤯','😬','😰','😱','🥵','🥶','😳','🤪','😵','🥴',
    '😠','😡','🤬','😷','🤒','🤕','🤢','🤮','🤧','😇',
    '🥳','🥺','🤠','🤡','👻','💀','🤖','🎃', '❤️','🩷',
    '🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️',
    '💕','💞','💓','💗','💖','💘','💝','💟'
  ],

  people: [
    '👍','👎','✌️','🤞','🤟','🤘','👌','🤌','🤏','👈',
    '👉','👆','👇','☝️','✋','🤚','🖐️','🖖','👋','🤙',
    '💪','🙏','👏','🙌','👐','🤲','🤝','👊','🤛','🤜',
    '💅','👀','👁️','👄','👅'
  ],

  animals: [
    '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯',
    '🦁','🐮','🐷','🐸','🐵','🐔','🐧','🐦','🦆','🦅',
    '🦉','🐺','🐗','🐴','🦄','🐝','🪲','🐞','🦋','🐢'
  ],

  food: [
    '🍏','🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐',
    '🍒','🍑','🥭','🍍','🥥','🥝','🍅','🥑','🥦','🥕',
    '🌽','🌶️','🥔','🍞','🥐','🥨','🧀','🍕','🍔','🍟',
    '🌭','🥪','🌮','🌯','🥗','🍝','🍣','🍱','🍤','🍩'
  ],

  sports: [
    '⚽','🏀','🏈','⚾','🎾','🏐','🏉','🥏','🎱','🎳',
    '🏓','🥅','🥊','🥋','⛳','🎣','🚴','🏃','⛷️','🏂'
  ],

  objects: [
    '💡','🔧','🪛','🪚','🔨','📎','📌','📍','✂️','🖊️',
    '🖋️','✏️','📒','📘','📙','📚','📄','📁','📂','🗂️',
    '💾','💿','📱','💻','🖥️','🖨️','⌨️','🖱️','🎧','📺',
    '📡'
  ],

//  flags: [
//   // 🌐 International
//   '🇺🇳','🇪🇺',

//   // 🌍 Africa
//   '🇦🇴','🇧🇫','🇧🇮','🇧🇯','🇧🇼','🇨🇫','🇨🇬','🇨🇩','🇨🇮','🇨🇲','🇨🇻','🇩🇯','🇩🇿',
//   '🇪🇬','🇪🇭','🇪🇬','🇬🇦','🇬🇭','🇬🇲','🇬🇳','🇬🇶','🇬🇼','🇰🇪','🇱🇸','🇱🇷','🇱🇾',
//   '🇲🇦','🇲🇬','🇲🇱','🇲🇷','🇲🇺','🇲🇼','🇲🇿','🇳🇦','🇳🇬','🇳🇪','🇷🇼','🇸🇨','🇸🇩',
//   '🇸🇱','🇸🇳','🇸🇴','🇸🇸','🇸🇿','🇹🇿','🇹🇬','🇹🇳','🇺🇬','🇿🇦','🇿🇲','🇿🇼',

//   // 🌎 North America
//   '🇦🇮','🇦🇬','🇦🇼','🇧🇧','🇧🇱','🇧🇲','🇧🇶','🇧🇸','🇧🇿','🇨🇦','🇨🇱','🇨🇴','🇨🇷',
//   '🇨🇺','🇨🇼','🇩🇲','🇩🇴','🇬🇩','🇬🇱','🇬🇹','🇭🇹','🇭🇳','🇯🇲','🇲🇫','🇲🇶','🇲🇸',
//   '🇳🇮','🇵🇦','🇵🇪','🇵🇷','🇰🇳','🇱🇨','🇻🇨','🇸🇽','🇹🇹','🇹🇨','🇺🇸','🇻🇪','🇻🇮',

//   // 🌎 Central America (Slack sometimes groups with NA)
//   '🇸🇻','🇲🇽',

//   // 🌎 South America (Slack groups fully alphabetically)
//   '🇦🇷','🇧🇴','🇧🇷','🇨🇱','🇨🇴','🇪🇨','🇬🇾','🇵🇦','🇵🇾','🇵🇪','🇸🇷','🇺🇾',

//   // 🌏 Asia
//   '🇦🇪','🇦🇫','🇦🇲','🇦🇿','🇧🇩','🇧🇭','🇧🇳','🇧🇹','🇨🇳','🇭🇰','🇮🇳','🇮🇩','🇮🇱',
//   '🇮🇶','🇮🇷','🇯🇴','🇯🇵','🇰🇿','🇰🇭','🇰🇼','🇰🇬','🇱🇦','🇱🇧','🇱🇰','🇲🇲','🇲🇳',
//   '🇲🇴','🇲🇻','🇲🇾','🇳🇵','🇴🇲','🇵🇭','🇵🇰','🇶🇦','🇸🇦','🇸🇬','🇸🇯','🇰🇷','🇸🇾',
//   '🇹🇭','🇹🇯','🇹🇲','🇹🇷','🇹🇼','🇺🇿','🇻🇳','🇾🇪',

//   // 🌍 Europe
//   '🇦🇱','🇦🇩','🇦🇹','🇧🇪','🇧🇬','🇧🇦','🇧🇾','🇨🇭','🇨🇿','🇩🇪','🇩🇰','🇪🇪','🇪🇸',
//   '🇫🇴','🇫🇮','🇫🇷','🇬🇧','🇬🇬','🇬🇮','🇬🇷','🇭🇷','🇭🇺','🇮🇪','🇮🇸','🇮🇹','🇯🇪',
//   '🇽🇰','🇱🇮','🇱🇹','🇱🇺','🇱🇻','🇲🇹','🇲🇩','🇲🇨','🇲🇰','🇲🇪','🇳🇱','🇳🇴','🇵🇱',
//   '🇵🇹','🇷🇴','🇷🇺','🇸🇪','🇸🇮','🇸🇰','🇸🇲','🇷🇸','🇺🇦','🇻🇦',

//   // 🌏 Oceania
//   '🇦🇸','🇦🇺','🇨🇰','🇫🇯','🇬🇺','🇰🇮','🇲🇭','🇲🇵','🇳🇨','🇳🇫','🇳🇷','🇳🇿','🇵🇬',
//   '🇵🇼','🇵🇫','🇵🇳','🇼🇸','🇸🇧','🇹🇰','🇹🇴','🇹🇻','🇻🇺'
// ],
celebrations: [
  // Christmas / Winter Holidays
  '🎄','🎁','🎅','🤶','🧑‍🎄','🦌','🔔','⛄','☃️','❄️',
  '🌟','✨','⭐','🌠','🕯️','🎀','🎗️','🌲','🍪','🥛',
  '🍫','🧦','🧣','🧤','🔥','🌨️','🎶','❇️','☕','🍷',

  // Hanukkah / Jewish Celebrations
  '🕎','🕯️','✨','⭐','🥯','🍩','🍪','🍬','🎁',
  '✡️','📿','🫓','🍷','🍇',

  // New Year / Fireworks / Party
  '🎉','🎊','🎆','🎇','🥳','🍾','🥂','🍻','🍸','🍹',
  '🍷','🕛','🎈','🎟️','🎠','🎡','🪅','🪩','🎤','🎧',
  '🎼','🎵','🎶','💃','🕺','🥁','🎷','🎺','🎸','🎻',

  // Birthdays / Cakes / Sweets
  '🎂','🧁','🍰','🍨','🍧','🍦','🍮','🍭','🍬',

  // Feasts / Thanksgiving / Harvest
  '🦃','🥧','🍗','🥘','🌽','🍠','🍞','🧈','🥖',
  '🥔','🥗','🍲','🍛','🍜','🫕',

  // Lunar New Year / Asian Celebrations
  '🧧','🏮','🐉','🐲','🧨','🎑','🥮','🧋','🍊','🐅',
  '🐇','🐉','🧧','💴','🎍',

  // Diwali / Festival of Lights (added)
  '🪔','🎆','🌼','🌸','🪮','🛕',

  // Halloween
  '🎃','👻','🧙‍♀️','🧙‍♂️','🧛','🧟','🧞','🧜','🕸️',
  '🕷️','🧹','💀','☠️','🕯️','🍬','🍭','🧪',

  // Weddings / Romance / Love
  '💍','💒','👰','🤵','💑','💏','❤️','💕','💞','💓',
  '💗','💘','💝','🌹','💐',

  // Religious / Cultural Celebrations
  '🕌','🕍','⛪','🕋','🛕','📿','🌙','⭐','🧕','🕯️',

  // Achievements / Misc Celebratory Symbols
  '🏆','🥇','🥈','🥉','🎖️','🏅','📣','🎥','🎬',
  '🎦','🎪','🪩','🧨','🎭','🎟️'
],



  custom: [
    '🍂','🍁','💐','🌹','🌻','☔','🍷','🍾','🙏','🎵','🎶','🎼','🎤'
  ]



};


// -------------------------------
// KEYWORDS FOR SEARCH
// -------------------------------
export const EMOJI_KEYWORDS: Record<string, string[]> = {

  "😀": ["smile","happy","grin"],
  "😁": ["grin","happy","big"],
  "😂": ["laugh","lol","tears"],
  "🤣": ["rolling","laugh","lol"],
  "😃": ["smile","joy","happy"],
  "😄": ["smile","cheerful","joy"],
  "😅": ["relief","smile","nervous"],
  "😆": ["laugh","haha","joy"],
  "😉": ["wink","playful","flirt"],
  "😊": ["smile","blush","warm"],
  "😋": ["yum","taste","delicious"],
  "😎": ["cool","sunglasses","chill"],
  "😍": ["love","heart","eyes"],
  "😘": ["kiss","love","heart"],
  "😗": ["kiss","face","peck"],
  "😙": ["kiss","smile","happy"],
  "😚": ["kiss","blush","shy"],
  "🙂": ["smile","soft","mild"],
  "🤗": ["hug","warm","welcome"],
  "🤩": ["star","excited","wow"],
  "🤔": ["think","hmm","question"],
  "🤨": ["skeptical","doubt","suspicious"],
  "😐": ["neutral","flat","meh"],
  "😑": ["expressionless","blank","neutral"],
  "😶": ["silent","blank","mouthless"],
  "🙄": ["eyeroll","annoyed","sarcasm"],
  "😏": ["smirk","side","flirt"],
  "😣": ["persevere","pain","struggle"],
  "😥": ["sad","relief","upset"],
  "😮": ["wow","surprised","shock"],
  "🤐": ["zipper","quiet","secret"],
  "😯": ["surprised","shock","wow"],
  "😪": ["sleepy","tired","droopy"],
  "😫": ["tired","upset","exhausted"],
  "😴": ["sleep","zzz","tired"],
  "😌": ["relaxed","calm","relief"],
  "🤤": ["drool","hungry","yum"],
  "😛": ["tongue","playful","silly"],
  "😜": ["wink","tongue","crazy"],
  "😝": ["tongue","silly","gross"],
  "😒": ["unamused","meh","annoyed"],
  "😓": ["sweat","sad","tired"],
  "😔": ["sad","down","upset"],
  "😕": ["confused","unsure","puzzled"],
  "🙃": ["upside","sarcasm","flip"],
  "🫠": ["melting","heat","melt"],
  "🤑": ["money","greedy","rich"],
  "😲": ["astonished","shock","wow"],
  "☹️": ["frown","sad","unhappy"],
  "🙁": ["sad","frown","unhappy"],
  "😖": ["confounded","pain","frustrated"],
  "😞": ["disappointed","sad","down"],
  "😟": ["worried","sad","concerned"],
  "😤": ["steam","angry","frustrated"],
  "😢": ["cry","sad","tears"],
  "😭": ["tears","crying","sob"],
  "😦": ["frown","shock","openmouth"],
  "😧": ["anguish","fear","worried"],
  "😨": ["fear","scared","terrified"],
  "😩": ["weary","tired","exhausted"],
  "🤯": ["mindblown","shock","explode"],
  "😬": ["grimace","awkward","nervous"],
  "😰": ["cold","fear","worried"],
  "😱": ["scream","horror","shock"],
  "🥵": ["hot","heat","sweat"],
  "🥶": ["cold","freeze","ice"],
  "😳": ["flushed","embarrassed","shy"],
  "🤪": ["crazy","goofy","wild"],
  "😵": ["dizzy","wow","spiral"],
  "🥴": ["woozy","drunk","dizzy"],
  "😠": ["mad","angry","annoyed"],
  "😡": ["rage","angry","furious"],
  "🤬": ["swear","angry","censor"],
  "😷": ["mask","sick","ill"],
  "🤒": ["thermometer","sick","fever"],
  "🤕": ["injured","hurt","bandage"],
  "🤢": ["nausea","sick","green"],
  "🤮": ["vomit","gross","throwup"],
  "🤧": ["sneeze","sick","allergy"],
  "😇": ["angel","halo","innocent"],
  "🥳": ["party","celebrate","festive"],
  "🥺": ["pleading","please","begging"],
  "🤠": ["cowboy","hat","western"],
  "🤡": ["clown","funny","circus"],
  "👻": ["ghost","boo","spooky"],
  "💀": ["skull","dead","bones"],
  "🤖": ["robot","bot","AI"],
  "🎃": ["pumpkin","halloween","spooky"],

  // PEOPLE
  "👍": ["thumb","up","like"],
  "👎": ["thumb","down","dislike"],
  "✌️": ["peace","v","two"],
  "🤞": ["cross","luck","fingers"],
  "🤟": ["love","hand","rock"],
  "🤘": ["rock","horns","metal"],
  "👌": ["ok","fine","perfect"],
  "🤌": ["pinched","hand","italian"],
  "🤏": ["pinch","small","tiny"],
  "👈": ["point","left","direction"],
  "👉": ["point","right","direction"],
  "👆": ["point","up","direction"],
  "👇": ["point","down","direction"],
  "☝️": ["point","one","up"],
  "✋": ["hand","stop","halt"],
  "🤚": ["hand","raised","backhand"],
  "🖐️": ["hand","five","highfive"],
  "🖖": ["vulcan","hand","spock"],
  "👋": ["wave","hello","bye"],
  "🤙": ["call","hangloose","shaka"],
  "💪": ["muscle","strong","flex"],
  "🙏": ["pray","thanks","please"],
  "👏": ["clap","applause","bravo"],
  "🙌": ["praise","up","celebrate"],
  "👐": ["open","hands","hug"],
  "🤲": ["cupped","hands","give"],
  "🤝": ["handshake","deal","agreement"],
  "👊": ["fist","bump","punch"],
  "🤛": ["fist","left","punch"],
  "🤜": ["fist","right","punch"],
  "💅": ["nails","beauty","manicure"],
  "👀": ["eyes","look","watch"],
  "👁️": ["eye","see","vision"],
  "👄": ["mouth","lips","kiss"],
  "👅": ["tongue","taste","lick"],

  // HEARTS
  "❤️": ["heart","love","red"],
  "🩷": ["heart","pink","love"],
  "🧡": ["heart","orange","love"],
  "💛": ["heart","yellow","love"],
  "💚": ["heart","green","love"],
  "💙": ["heart","blue","love"],
  "💜": ["heart","purple","love"],
  "🖤": ["heart","black","goth"],
  "🤍": ["heart","white","pure"],
  "🤎": ["heart","brown","love"],
  "💔": ["broken","heart","sad"],
  "❣️": ["heart","exclaim","love"],
  "💕": ["hearts","love","couple"],
  "💞": ["hearts","revolve","circle"],
  "💓": ["heartbeat","love","pulse"],
  "💗": ["heart","grow","bloom"],
  "💖": ["sparkle","heart","sparkling"],
  "💘": ["arrow","heart","cupid"],
  "💝": ["heart","gift","present"],
  "💟": ["heart","decor","ornament"],

  // ANIMALS
  "🐶": ["dog","puppy","pet"],
  "🐱": ["cat","kitty","pet"],
  "🐭": ["mouse","rodent","small"],
  "🐹": ["hamster","pet","cute"],
  "🐰": ["rabbit","bunny","hop"],
  "🦊": ["fox","animal","clever"],
  "🐻": ["bear","animal","wild"],
  "🐼": ["panda","bear","cute"],
  "🐨": ["koala","bear","australia"],
  "🐯": ["tiger","cat","wild"],
  "🦁": ["lion","cat","king"],
  "🐮": ["cow","ox","farm"],
  "🐷": ["pig","hog","farm"],
  "🐸": ["frog","amphibian","ribbit"],
  "🐵": ["monkey","ape","primate"],
  "🐔": ["chicken","bird","farm"],
  "🐧": ["penguin","bird","cold"],
  "🐦": ["bird","tweet","fly"],
  "🦆": ["duck","bird","quack"],
  "🦅": ["eagle","bird","freedom"],
  "🦉": ["owl","bird","night"],
  "🐺": ["wolf","animal","howl"],
  "🐗": ["boar","pig","wild"],
  "🐴": ["horse","pony","ride"],
  "🦄": ["unicorn","horse","magic"],
  "🐝": ["bee","insect","honey"],
  "🪲": ["beetle","bug","insect"],
  "🐞": ["ladybug","insect","spot"],
  "🦋": ["butterfly","insect","fly"],
  "🐢": ["turtle","reptile","slow"],

  // FOOD
  "🍏": ["apple","green","fruit"],
  "🍎": ["apple","red","fruit"],
  "🍐": ["pear","fruit","green"],
  "🍊": ["orange","fruit","citrus"],
  "🍋": ["lemon","fruit","sour"],
  "🍌": ["banana","fruit","yellow"],
  "🍉": ["watermelon","fruit","summer"],
  "🍇": ["grapes","fruit","bunch"],
  "🍓": ["strawberry","fruit","sweet"],
  "🫐": ["blueberries","fruit","berry"],
  "🍒": ["cherry","fruit","red"],
  "🍑": ["peach","fruit","sweet"],
  "🥭": ["mango","fruit","tropical"],
  "🍍": ["pineapple","fruit","tropical"],
  "🥥": ["coconut","fruit","tropical"],
  "🥝": ["kiwi","fruit","green"],
  "🍅": ["tomato","fruit","red"],
  "🥑": ["avocado","fruit","green"],
  "🥦": ["broccoli","veggie","green"],
  "🥕": ["carrot","veggie","orange"],
  "🌽": ["corn","veggie","yellow"],
  "🌶️": ["chili","pepper","spicy"],
  "🥔": ["potato","veggie","starch"],
  "🍞": ["bread","loaf","baked"],
  "🥐": ["croissant","bread","baked"],
  "🥨": ["pretzel","snack","twist"],
  "🧀": ["cheese","food","dairy"],
  "🍕": ["pizza","slice","cheese"],
  "🍔": ["burger","sandwich","beef"],
  "🍟": ["fries","fastfood","potato"],
  "🌭": ["hotdog","sausage","bun"],
  "🥪": ["sandwich","lunch","food"],
  "🌮": ["taco","mexican","food"],
  "🌯": ["burrito","mexican","wrap"],
  "🥗": ["salad","veggie","healthy"],
  "🍝": ["pasta","noodles","italian"],
  "🍣": ["sushi","fish","japanese"],
  "🍱": ["bento","japanese","meal"],
  "🍤": ["shrimp","fried","seafood"],
  "🍩": ["donut","sweet","dessert"],

  // SPORTS
  "⚽": ["soccer","football","sport"],
  "🏀": ["basketball","sports","ball"],
  "🏈": ["football","american","sport"],
  "⚾": ["baseball","sports","ball"],
  "🎾": ["tennis","sports","ball"],
  "🏐": ["volleyball","sports","ball"],
  "🏉": ["rugby","sports","ball"],
  "🥏": ["frisbee","disc","sport"],
  "🎱": ["billiards","pool","eightball"],
  "🎳": ["bowling","sports","pins"],
  "🏓": ["pingpong","tabletennis","paddle"],
  "🥅": ["goal","net","sport"],
  "🥊": ["boxing","fight","gloves"],
  "🥋": ["martialarts","karate","judo"],
  "⛳": ["golf","sports","flag"],
  "🎣": ["fishing","sport","hook"],
  "🚴": ["cycling","bike","ride"],
  "🏃": ["running","exercise","jog"],
  "⛷️": ["ski","winter","snow"],
  "🏂": ["snowboard","winter","snow"],

  // OBJECTS
  "💡": ["idea","lightbulb","bright"],
  "🔧": ["wrench","tool","fix"],
  "🪛": ["screwdriver","tool","fix"],
  "🪚": ["saw","tool","wood"],
  "🔨": ["hammer","tool","build"],
  "📎": ["paperclip","office","attach"],
  "📌": ["pushpin","pin","location"],
  "📍": ["location","pin","marker"],
  "✂️": ["scissors","cut","trim"],
  "🖊️": ["pen","write","ink"],
  "🖋️": ["fountainpen","write","ink"],
  "✏️": ["pencil","write","draw"],
  "📒": ["notebook","notes","journal"],
  "📘": ["book","bluebook","read"],
  "📙": ["book","orangebook","read"],
  "📚": ["books","library","study"],
  "📄": ["document","paper","file"],
  "📁": ["folder","files","directory"],
  "📂": ["folder","open","documents"],
  "🗂️": ["cardindex","files","organize"],
  "💾": ["disk","save","floppy"],
  "💿": ["cd","disc","music"],
  "📱": ["phone","mobile","call"],
  "💻": ["laptop","computer","tech"],
  "🖥️": ["desktop","computer","monitor"],
  "🖨️": ["printer","office","print"],
  "⌨️": ["keyboard","tech","type"],
  "🖱️": ["mouse","tech","click"],
  "🎧": ["headphones","music","audio"],
  "📺": ["tv","television","screen"],
  "📡": ["satellite","signal","antenna"],

  // CUSTOM
  "🍂": ["leaf","fall","autumn"],
  "🍁": ["maple","leaf","canada"],
  "💐": ["bouquet","flowers","gift"],
  "🌹": ["rose","flower","love"],
  "🌻": ["sunflower","flower","yellow"],
  "☔": ["umbrella","rain","wet"],
  "🍷": ["wine","drink","alcohol"],
  "🍾": ["champagne","bottle","celebration"],
  "🎵": ["music","note","melody"],
  "🎶": ["music","notes","song"],
  "🎼": ["sheetmusic","score","music"],
  "🎤": ["microphone","sing","karaoke"],
  // --- FLAGS (continents + regions + country names) ---

  // // International
  // "🇺🇳": ["un","united nations","international"],
  // "🇪🇺": ["eu","european union","europe"],

  // // Africa
  // "🇦🇴": ["angola","africa"],
  // "🇧🇫": ["burkina faso","africa"],
  // "🇧🇮": ["burundi","africa"],
  // "🇧🇯": ["benin","africa"],
  // "🇧🇼": ["botswana","africa"],
  // "🇨🇫": ["central african republic","car","africa"],
  // "🇨🇬": ["congo","republic of congo","africa"],
  // "🇨🇩": ["drc","congo kinshasa","democratic republic of congo","africa"],
  // "🇨🇮": ["ivory coast","cote d'ivoire","africa"],
  // "🇨🇲": ["cameroon","africa"],
  // "🇨🇻": ["cape verde","cabo verde","africa"],
  // "🇩🇯": ["djibouti","africa"],
  // "🇩🇿": ["algeria","africa"],
  // "🇪🇬": ["egypt","africa","north africa"],
  // "🇬🇦": ["gabon","africa"],
  // "🇬🇭": ["ghana","africa"],
  // "🇬🇲": ["gambia","africa"],
  // "🇬🇳": ["guinea","africa"],
  // "🇬🇶": ["equatorial guinea","africa"],
  // "🇬🇼": ["guinea-bissau","africa"],
  // "🇰🇪": ["kenya","africa"],
  // "🇱🇸": ["lesotho","africa"],
  // "🇱🇷": ["liberia","africa"],
  // "🇱🇾": ["libya","africa"],
  // "🇲🇦": ["morocco","africa"],
  // "🇲🇬": ["madagascar","africa"],
  // "🇲🇱": ["mali","africa"],
  // "🇲🇷": ["mauritania","africa"],
  // "🇲🇺": ["mauritius","africa"],
  // "🇲🇼": ["malawi","africa"],
  // "🇲🇿": ["mozambique","africa"],
  // "🇳🇦": ["namibia","africa"],
  // "🇳🇬": ["nigeria","africa"],
  // "🇳🇪": ["niger","africa"],
  // "🇷🇼": ["rwanda","africa"],
  // "🇸🇨": ["seychelles","africa"],
  // "🇸🇩": ["sudan","africa"],
  // "🇸🇱": ["sierra leone","africa"],
  // "🇸🇳": ["senegal","africa"],
  // "🇸🇴": ["somalia","africa"],
  // "🇸🇸": ["south sudan","africa"],
  // "🇸🇿": ["eswatini","swaziland","africa"],
  // "🇹🇿": ["tanzania","africa"],
  // "🇹🇬": ["togo","africa"],
  // "🇹🇳": ["tunisia","africa"],
  // "🇺🇬": ["uganda","africa"],
  // "🇿🇦": ["south africa","africa"],
  // "🇿🇲": ["zambia","africa"],
  // "🇿🇼": ["zimbabwe","africa"],

  // // North America & Caribbean
  // "🇦🇮": ["anguilla","caribbean"],
  // "🇦🇬": ["antigua","barbuda","caribbean"],
  // "🇦🇼": ["aruba","caribbean"],
  // "🇧🇧": ["barbados","caribbean"],
  // "🇧🇱": ["saint barthelemy","caribbean"],
  // "🇧🇲": ["bermuda","caribbean"],
  // "🇧🇶": ["caribbean netherlands","bonaire","statia","saba"],
  // "🇧🇸": ["bahamas","caribbean"],
  // "🇧🇿": ["belize","central america"],
  // "🇨🇦": ["canada","north america"],
  // "🇨🇱": ["chile","south america"],
  // "🇨🇴": ["colombia","south america"],
  // "🇨🇷": ["costa rica","central america"],
  // "🇨🇺": ["cuba","caribbean"],
  // "🇨🇼": ["curacao","caribbean"],
  // "🇩🇲": ["dominica","caribbean"],
  // "🇩🇴": ["dominican republic","caribbean"],
  // "🇬🇩": ["grenada","caribbean"],
  // "🇬🇱": ["greenland","north america"],
  // "🇬🇹": ["guatemala","central america"],
  // "🇭🇹": ["haiti","caribbean"],
  // "🇭🇳": ["honduras","central america"],
  // "🇯🇲": ["jamaica","caribbean"],
  // "🇲🇫": ["saint martin","caribbean"],
  // "🇲🇶": ["martinique","caribbean"],
  // "🇲🇸": ["montserrat","caribbean"],
  // "🇳🇮": ["nicaragua","central america"],
  // "🇵🇦": ["panama","central america"],
  // "🇵🇷": ["puerto rico","caribbean"],
  // "🇰🇳": ["saint kitts","nevis","caribbean"],
  // "🇱🇨": ["saint lucia","caribbean"],
  // "🇻🇨": ["saint vincent","grenadines","caribbean"],
  // "🇸🇽": ["sint maarten","caribbean"],
  // "🇹🇹": ["trinidad","tobago","caribbean"],
  // "🇹🇨": ["turks","caicos","caribbean"],
  // "🇺🇸": ["usa","america","united states"],

  // // Central & South America
  // "🇸🇻": ["el salvador","central america"],
  // "🇲🇽": ["mexico","north america"],
  // "🇦🇷": ["argentina","south america"],
  // "🇧🇴": ["bolivia","south america"],
  // "🇧🇷": ["brazil","south america"],
  // "🇪🇨": ["ecuador","south america"],
  // "🇬🇾": ["guyana","south america"],
  // "🇵🇾": ["paraguay","south america"],
  // "🇵🇪": ["peru","south america"],
  // "🇸🇷": ["suriname","south america"],
  // "🇺🇾": ["uruguay","south america"],
  // "🇻🇪": ["venezuela","south america"],

  // // Asia
  // "🇦🇪": ["uae","emirates","middle east"],
  // "🇦🇫": ["afghanistan","asia"],
  // "🇦🇲": ["armenia","asia","caucasus"],
  // "🇦🇿": ["azerbaijan","asia","caucasus"],
  // "🇧🇩": ["bangladesh","asia"],
  // "🇧🇭": ["bahrain","middle east"],
  // "🇧🇳": ["brunei","asia"],
  // "🇧🇹": ["bhutan","asia"],
  // "🇨🇳": ["china","asia"],
  // "🇭🇰": ["hong kong","china"],
  // "🇮🇳": ["india","asia"],
  // "🇮🇩": ["indonesia","asia"],
  // "🇮🇱": ["israel","middle east"],
  // "🇮🇶": ["iraq","middle east"],
  // "🇮🇷": ["iran","middle east"],
  // "🇯🇴": ["jordan","middle east"],
  // "🇯🇵": ["japan","asia"],
  // "🇰🇿": ["kazakhstan","asia"],
  // "🇰🇭": ["cambodia","asia"],
  // "🇰🇼": ["kuwait","middle east"],
  // "🇰🇬": ["kyrgyzstan","asia"],
  // "🇱🇦": ["laos","asia"],
  // "🇱🇧": ["lebanon","middle east"],
  // "🇱🇰": ["sri lanka","asia"],
  // "🇲🇲": ["myanmar","burma","asia"],
  // "🇲🇳": ["mongolia","asia"],
  // "🇲🇻": ["maldives","asia"],
  // "🇲🇾": ["malaysia","asia"],
  // "🇳🇵": ["nepal","asia"],
  // "🇴🇲": ["oman","middle east"],
  // "🇵🇭": ["philippines","asia"],
  // "🇵🇰": ["pakistan","asia"],
  // "🇶🇦": ["qatar","middle east"],
  // "🇸🇦": ["saudi arabia","middle east"],
  // "🇸🇬": ["singapore","asia"],
  // "🇰🇷": ["south korea","korea","asia"],
  // "🇸🇾": ["syria","middle east"],
  // "🇹🇭": ["thailand","asia"],
  // "🇹🇯": ["tajikistan","asia"],
  // "🇹🇲": ["turkmenistan","asia"],
  // "🇹🇷": ["turkey","turkiye","asia","europe"],
  // "🇹🇼": ["taiwan","asia"],
  // "🇺🇿": ["uzbekistan","asia"],
  // "🇻🇳": ["vietnam","asia"],
  // "🇾🇪": ["yemen","middle east"],

  // // Europe
  // "🇦🇱": ["albania","europe"],
  // "🇦🇩": ["andorra","europe"],
  // "🇦🇹": ["austria","europe"],
  // "🇧🇪": ["belgium","europe"],
  // "🇧🇬": ["bulgaria","europe"],
  // "🇧🇦": ["bosnia","herzegovina","europe"],
  // "🇧🇾": ["belarus","europe"],
  // "🇨🇭": ["switzerland","europe"],
  // "🇨🇿": ["czech","czechia","europe"],
  // "🇩🇪": ["germany","europe"],
  // "🇩🇰": ["denmark","europe"],
  // "🇪🇪": ["estonia","europe"],
  // "🇪🇸": ["spain","europe"],
  // "🇫🇴": ["faroe islands","europe"],
  // "🇫🇮": ["finland","europe"],
  // "🇫🇷": ["france","europe"],
  // "🇬🇧": ["uk","britain","england","united kingdom"],
  // "🇬🇬": ["guernsey","europe"],
  // "🇬🇮": ["gibraltar","europe"],
  // "🇬🇷": ["greece","europe"],
  // "🇭🇷": ["croatia","europe"],
  // "🇭🇺": ["hungary","europe"],
  // "🇮🇪": ["ireland","europe"],
  // "🇮🇸": ["iceland","europe"],
  // "🇮🇹": ["italy","europe"],
  // "🇯🇪": ["jersey","europe"],
  // "🇽🇰": ["kosovo","europe"],
  // "🇱🇮": ["liechtenstein","europe"],
  // "🇱🇹": ["lithuania","europe"],
  // "🇱🇺": ["luxembourg","europe"],
  // "🇱🇻": ["latvia","europe"],
  // "🇲🇹": ["malta","europe"],
  // "🇲🇩": ["moldova","europe"],
  // "🇲🇨": ["monaco","europe"],
  // "🇲🇰": ["north macedonia","europe"],
  // "🇲🇪": ["montenegro","europe"],
  // "🇳🇱": ["netherlands","europe"],
  // "🇳🇴": ["norway","europe"],
  // "🇵🇱": ["poland","europe"],
  // "🇵🇹": ["portugal","europe"],
  // "🇷🇴": ["romania","europe"],
  // "🇷🇺": ["russia","europe","asia"],
  // "🇸🇪": ["sweden","europe"],
  // "🇸🇮": ["slovenia","europe"],
  // "🇸🇰": ["slovakia","europe"],
  // "🇸🇲": ["san marino","europe"],
  // "🇷🇸": ["serbia","europe"],
  // "🇺🇦": ["ukraine","europe"],
  // "🇻🇦": ["vatican","holy see","europe"],

  // // Oceania
  // "🇦🇸": ["american samoa","oceania"],
  // "🇦🇺": ["australia","oceania"],
  // "🇨🇰": ["cook islands","oceania"],
  // "🇫🇯": ["fiji","oceania"],
  // "🇬🇺": ["guam","oceania"],
  // "🇰🇮": ["kiribati","oceania"],
  // "🇲🇭": ["marshall islands","oceania"],
  // "🇲🇵": ["northern mariana islands","oceania"],
  // "🇳🇨": ["new caledonia","oceania"],
  // "🇳🇫": ["norfolk island","oceania"],
  // "🇳🇷": ["nauru","oceania"],
  // "🇳🇿": ["new zealand","oceania"],
  // "🇵🇬": ["papua new guinea","oceania"],
  // "🇵🇼": ["palau","oceania"],
  // "🇵🇫": ["french polynesia","oceania"],
  // "🇵🇳": ["pitcairn","oceania"],
  // "🇼🇸": ["samoa","oceania"],
  // "🇸🇧": ["solomon islands","oceania"],
  // "🇹🇰": ["tokelau","oceania"],
  // "🇹🇴": ["tonga","oceania"],
  // "🇹🇻": ["tuvalu","oceania"],
  // "🇻🇺": ["vanuatu","oceania"],
}


// -------------------------------
// HELPERS
// -------------------------------

// Get emojis for a category
export function getCategoryEmojis(category: string): string[] {
  return EMOJI_DATA[category] || [];
}

// Flatten all emojis into one array
export function getAllEmojiList(): string[] {
  return Object.values(EMOJI_DATA).flat();
}


/* Full Slack-style emoticon → emoji conversion */
export const EMOTICON_MAP: Record<string, string> = {
  /* Happy / Smile */
  ":)": "🙂",
  ":-)": "🙂",
  ":]": "🙂",
  "=)": "🙂",
  ":D": "😁",
  ":-D": "😁",
  "=D": "😁",
  "XD": "😆",
  "xD": "😆",

  /* Laughing / Joy */
  ":')": "😂",
  ":'-)": "😂",

  /* Sad */
  ":(": "🙁",
  ":-(": "🙁",
  ":'(": "😢",
  ":'-(": "😢",
  "=(": "🙁",

  /* Wink */
  ";)": "😉",
  ";-)": "😉",

  /* Tongue / Playful */
  ":P": "😛",
  ":-P": "😛",
  ":p": "😛",
  ":-p": "😛",
  "=P": "😛",
  ":b": "😛",
  ":-b": "😛",

  /* Shock / Surprise */
  ":O": "😮",
  ":-O": "😮",
  ":o": "😮",
  ":-o": "😮",

  /* Confused / Skeptical */
  ":/": "😕",
  ":-/": "😕",
  ":\\": "😕",
  ":-\\": "😕",
  ":|": "😐",
  ":-|": "😐",

  /* Love / Hearts */
  "<3": "❤️",
  "</3": "💔",

  /* Cool */
  "8)": "😎",
  "8-)": "😎",
  "B)": "😎",
  "B-)": "😎",

  /* Angry / Annoyed */
  ">:(": "😠",
  ">:-(": "😠",

  /* Shocked / WTF */
  "O_O": "😳",
  "o_o": "😳",
  "O.o": "😳",
  "o.O": "😳",
  "0_0": "😳",

  /* Sleepy / Unamused */
  "-_-": "😑",

  /* Happy eyes */
  "^_^": "😊",
  "^^": "😊",

  /* Crying */
  "T_T": "😭",
  "TT_TT": "😭",

  /* Kiss */
  ":*": "😘",
  ":-*": "😘",

  /* Cat smile (classic) */
  ":3": "😺",

  /* Big grin */
  ":^)": "😄",
  ":-^)": "😄"
};

